import { REVIEW_ROUTE_NAME } from '@/libs/route-name';

export const reviewsRoute = () => {
  return {
    name: REVIEW_ROUTE_NAME.LIST_REVIEW,
    path: 'reviews',
    component: () => import('@/pages/reviews/index.vue'),
    // meta: { onlyGuest: false }
  };
};
